import React from "react";
import Proptypes from "prop-types";
import HubspotForm from "react-hubspot-form";
import $ from "jquery";

import Modal from "../Modal/Modal";
import { setCookie, getCookieValue } from "../Utiilities/Cookies";
// import axios from "axios";

//for huspot form submit :(
window.jQuery = $;
window.$ = $;
global.jQuery = $;

class MagazineGate extends React.Component {
  static defaultProps = {
    text: "",
    classes: "",
    glyph: "",
    redirectUrl: "",
    sitename: ""
  };

  static propTypes = {
    text: Proptypes.string,
    classes: Proptypes.string,
    glyph: Proptypes.string,
    redirectUrl: Proptypes.string,
    sitename: Proptypes.string
  };

  state = {
    open: false,
    hutk: "",
    hubspotEmail: "",
    error: ""
  };

  checkGatedAccess = () => {
    let email = getCookieValue("hubspotemail");
    if (email) {
      this.setState({
        hubspotEmail: email
      });
      window.open(this.props.redirectUrl, "_blank", "noopener");
    } else {
      if (this.state.open) {
        this.closeModal();
      } else {
        this.openModal();
      }
    }
  };

  closeModal = () => {
    this.setState({
      open: false,
      error: ""
    });
  };

  openModal = () => {
    this.setState({
      open: true,
      error: ""
    });
  };

  componentDidMount() {
    let hutk = getCookieValue("hubspotutk");
    let hubspotEmail = getCookieValue("hubspotemail");

    this.setState({
      hutk,
      hubspotEmail
    });
  }

  getGlyph = () => {
    if (this.props.glyph) {
      return <i className={this.props.glyph} aria-hidden="true" />;
    }
  };

  onSubmit = (fields) => {
    if (fields.length && fields.length > 1) {
      fields.pop(); //get rid of last one for the download button
      let email = "";

      for (let i = 0; i < fields.length; i++) {
        if (fields[i].name == "email") {
          email = fields[i].value;
          break;
        }
      }

      window.open(this.props.redirectUrl, "_blank", "noopener");

      setCookie("hubspotemail", email, 395);
      this.setState({
        hubspotEmail: email
      });
    } else {
      // we should display an error message and not redirect
      this.setState({
        error: "Please complete the required fields."
      });
    }
  };

  render() {
    let classes = "magazine-gate-content";
    if (this.state.error) {
      classes += " showing-error";
    }
    return (
      <div>
        {this.state.open && (
          <Modal>
            <div className="magazine-gate-modal">
              <div className={classes}>
                <div className="close-btn" onClick={this.closeModal}>
                  X
                </div>
                <HubspotForm portalId="547446" formId="2f17126d-a3f0-4f0c-88f2-fe008b425d01" onSubmit={this.onSubmit} />
                {this.state.error && <div className="invalid-feedback">{this.state.error}</div>}
              </div>
            </div>
          </Modal>
        )}
        <button className={this.props.classes} onClick={this.checkGatedAccess}>
          {this.getGlyph()}
          {this.props.text}
        </button>
      </div>
    );
  }
}

export default MagazineGate;
